import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { NotificationLocalModel } from '../../../models/notificationModel/NotificacionModelLocal';
import { NotificationService } from '../../../core/services/notification.service';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { GlobalComponents } from '../global-constants';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Language } from 'src/app/models/languageModel/language';
import { interval } from 'rxjs';
import { timeInterval } from 'rxjs/operators';
import { UtilService } from '../../../core/services/util.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})

export class NotificationComponent implements OnInit {

  public notificationsEs: NotificationLocalModel[] = null;
  public notificationsEn: NotificationLocalModel[] = null;
  status: boolean = false;

  //Front value
  public notifications = Array<NotificationLocalModel>();
  
  constructor(private dialog: MatDialog,
              private notificationservice: NotificationService,
              private translateService: TranslateService,
              private utilService: UtilService) {
                this.utilService.status$.subscribe((status: boolean) => {
                  this.status = status;
                })
              }

  ngOnInit(): void {
    this.getNotifications();
    const seconds = interval(900000);
    seconds.pipe(timeInterval()).subscribe(R =>
      this.getNotifications()
    );

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadNotificationsByLanguageCode(event.lang);
    });
  }

  getNotifications(){

    this.notificationservice.getNotRead(localStorage.getItem("username")).subscribe(resp =>{
      this.notificationsEs = Array<NotificationLocalModel>();
      this.notificationsEn = Array<NotificationLocalModel>();
      resp.data.forEach(element => {
        this.notificationsEs.push({
          id: element.notificationId,
          text: element.textEs
        });
        this.notificationsEn.push({
          id: element.notificationId,
          text: element.textEn
        });
      });

      let currentlangua: Language = JSON.parse(localStorage.getItem("languaje"));
      this.loadNotificationsByLanguageCode(currentlangua.code);

    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  loadNotificationsByLanguageCode(languageCode: string){
    if (languageCode == 'es') {
      this.notifications = this.notificationsEs;
    }
    else{
      this.notifications = this.notificationsEn;
    }
  }

  markAsRead(notificationId:number, index: number) {
    this.notificationservice.markAsRead(notificationId, localStorage.getItem("username")).subscribe(resp =>{
      this.notificationsEn?.splice(index, 1);
      this.notificationsEs?.splice(index, 1);
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  notificationModal(message: string){
    const dialogConfig = new MatDialogConfig();    
    dialogConfig.data = {
      message: message,
      valor:10
    }
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }
}
